export default __webpack_public_path__ + "static/image22-b7e0a3c7fdc21141602ffcc85de57e78.gif";